import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18CalendarB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h18v18H0z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        d: "M12.875 1c.345 0 .625.28.625.625v.75h.75c.966 0 1.75.784 1.75 1.75v10.5a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 14.625v-10.5c0-.966.784-1.75 1.75-1.75h.75v-.75a.625.625 0 1 1 1.25 0v.75h6.5v-.75c0-.345.28-.625.625-.625m2.031 5.75H3.093v7.875c0 .332.248.607.568.65l.089.006h10.5a.656.656 0 0 0 .65-.567l.006-.089zM4.5 3.468h-.75a.656.656 0 0 0-.65.568l-.006.089L3.093 5.5h11.813V4.125a.656.656 0 0 0-.567-.65l-.089-.006-.75-.001v.407a.625.625 0 1 1-1.25 0v-.407h-6.5v.407a.625.625 0 1 1-1.25 0z"
      }), /*#__PURE__*/jsx("rect", {
        width: 2,
        height: 1.25,
        x: 5.5,
        y: 9,
        fill: props.iconColor ? props.iconColor : "#010505",
        rx: 0.5
      }), /*#__PURE__*/jsx("rect", {
        width: 2,
        height: 1.25,
        x: 5.5,
        y: 12,
        fill: props.iconColor ? props.iconColor : "#010505",
        rx: 0.5
      }), /*#__PURE__*/jsx("rect", {
        width: 2,
        height: 1.25,
        x: 10.5,
        y: 9,
        fill: props.iconColor ? props.iconColor : "#010505",
        rx: 0.5
      }), /*#__PURE__*/jsx("rect", {
        width: 2,
        height: 1.25,
        x: 10.5,
        y: 12,
        fill: props.iconColor ? props.iconColor : "#010505",
        rx: 0.5
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18CalendarB$1 = Svg18CalendarB;

export { Svg18CalendarB$1 as default };
